/**
 * @summary
<blockquote>Ordered list of permission verbs for RBAC</blockquote>
 * @internal
 */
export const permissionOrder = [
  'read',
  'create',
  'update',
  'delete'
] as const; 